/* eslint-disable @typescript-eslint/no-unused-vars */
import { Router, NavigationEnd, ActivatedRoute } from '@angular/router';

import {
  Component,
  Inject,
  ElementRef,
  OnInit,
  Renderer2,
  HostListener,
  OnDestroy,
  ViewChildren,
  QueryList,
  DOCUMENT
} from '@angular/core';
import { ROUTES } from './sidebar-items';
import { RouteInfo } from './sidebar.metadata';
import { AuthService, Role } from '@core';
import { User } from 'firebase/auth';
import packageInfo from '../../../../package.json'
import { GlobalService } from 'app/services/global.service';
import { filter, Subscription } from 'rxjs';
@Component({
    selector: 'app-sidebar',
    templateUrl: './sidebar.component.html',
    styleUrls: ['./sidebar.component.scss'],
    standalone: false
})
export class SidebarComponent implements OnInit, OnDestroy {
  @ViewChildren('sidebarList') sidebarList: QueryList<ElementRef<HTMLUListElement>> | undefined

  public sidebarItems!: RouteInfo[];
  public innerHeight?: number;
  public bodyTag!: HTMLElement;
  listMaxHeight?: string;
  listMaxWidth?: string;
  userFullName?: string;
  userImg?: string;
  userType?: string = Role.Admin;
  headerHeight = 60;
  currentRoute?: string;
  routerObj;
  loggedInUser: any
  currentFacility: any
  appVersion: any
  claims: any;
  isSideBarCreated: boolean = false;
  userSubscription: any;
  facilitysubscription: Subscription | undefined;

  constructor(
    @Inject(DOCUMENT) private document: Document,
    private renderer: Renderer2,
    public elementRef: ElementRef,
    private authService: AuthService,
    private router: Router,
    private _auth: AuthService,
    public _glob: GlobalService,
    private _activatedRoute: ActivatedRoute
  ) {
    this.appVersion = packageInfo.version
  this.userSubscription =  _auth.currentUser?.subscribe(res => {
      console.log("================================",res);
      
      this.loggedInUser = _auth.currentUserValue
      if (this.isSideBarCreated == false && this.authService.currentUserValue.currentUser){
        console.log("KKKKKKKKKKKKKKKKKKKKKKKKKKKK",this.authService.currentUserValue.currentUser);
        
        this.makeSidebar()
        this.isSideBarCreated = true         
      }

    })
    // _auth.customClaims$.subscribe(res => {
    //   console.log(res, "=========");
    //   this.claims = res
    //   this.makeSidebar()
    // })
  this.facilitysubscription=  _auth.currentFacility?.subscribe({
      next: () => {
        this.currentFacility = _auth.currentFacilityDetails

      }
    })
    this.elementRef.nativeElement.closest('body');
    this.routerObj = this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        // close sidebar on mobile screen after menu select
        this.renderer.removeClass(this.document.body, 'overlay-open');
      }
    });
  }
  @HostListener('window:resize')
  windowResizecall() {
    this.setMenuHeight();
    this.checkStatuForResize(false);
  }
  @HostListener('document:mousedown', ['$event'])
  onGlobalClick(event: Event): void {
    if (!this.elementRef.nativeElement.contains(event.target)) {
      this.renderer.removeClass(this.document.body, 'overlay-open');
    }
  }

  callToggleMenu(event: Event, length: number) {
    if (length > 0) {
      const parentElement = (event.target as HTMLInputElement).closest('li');
      const activeClass = parentElement?.classList.contains('active');

      if (activeClass) {
        this.renderer.removeClass(parentElement, 'active');
      } else {
        this.renderer.addClass(parentElement, 'active');
      }
    }
  }
  ngOnInit() {
    this.mouseOut()
  }

  makeSidebar() {


    // if (this.authService.currentUserValue.currentUser) {
    // const userRole = this.authService.currentUserValue.role;  
    // const map:any = {
    //   "MaleMan Admin":Role.MaleManAdmin,
    //   "Admin":Role.Admin,
    //   "Buyer":Role.Buyer,
    //   "Lab Technician":Role.LabTechnician,
    // }
    if (this.authService.currentUserValue.currentUser) {

      this.userFullName =
        this.authService.currentUserValue.currentUser.data.firstName +
        ' ' +
        this.authService.currentUserValue.currentUser.data.lastName;
      this.userImg = this.authService.currentUserValue.currentUser.data.img;
      console.log("========= before view Init from SB", this.authService.currentUserValue);

      const userRole = this.authService.currentUserValue.currentUser.role
      // map[this.claims.claims.customClaims.role];


      this.sidebarItems = ROUTES.filter(
        (x) => x.role.indexOf(userRole) !== -1 || x.role.indexOf('All') !== -1
      );
      // If it is BEni's account then display the Dashboard
      // if(this.authService.currentUserValue.currentUser.data.email == "beni@mes-ltd.com"){
      //   this.sidebarItems.unshift(ROUTES[0])
      // }
      console.log("PPPPPPPPPP", userRole, ROUTES, this.sidebarItems);

    }


    // if (userRole === Role.Admin) {
    //   this.userType = Role.Admin;
    // } else if (userRole === Role.Patient) {
    //   this.userType = Role.Patient;
    // } else if (userRole === Role.Doctor) {
    //   this.userType = Role.Doctor;
    // } else {
    //   this.userType = Role.Admin;
    // }
    // }

    // this.sidebarItems = ROUTES.filter((sidebarItem) => sidebarItem);
    this.initLeftSidebar();
    this.bodyTag = this.document.body;


  }

  ngAfterViewInit() {
    console.log("========= before view Init from ngAfterViewInit", this.claims);
    this.makeSidebar()
  }

  ngOnDestroy() {
    this.routerObj.unsubscribe();
    this.userSubscription?.unsubscribe();
    this.facilitysubscription?.unsubscribe();
  }
  initLeftSidebar() {
    // eslint-disable-next-line @typescript-eslint/no-this-alias
    const _this = this;
    // Set menu height
    _this.setMenuHeight();
    _this.checkStatuForResize(true);
  }
  setMenuHeight() {
    this.innerHeight = window.innerHeight;
    const height = this.innerHeight - this.headerHeight;
    this.listMaxHeight = height + '';
    this.listMaxWidth = '500px';
  }
  isOpen() {
    return this.bodyTag.classList.contains('overlay-open');
  }

  checkStatuForResize(firstTime: boolean) {
    if (window.innerWidth < 1170) {
      this.renderer.addClass(this.document.body, 'ls-closed');
      this._glob.onSidebarOpen.next(false)
    } else {
      this.renderer.removeClass(this.document.body, 'ls-closed');
      const body = this.elementRef.nativeElement.closest('body');
      if (body?.classList?.contains('submenu-closed')) {
        console.log(true)
        this._glob.onSidebarOpen.next(false)
      } else {
        this._glob.onSidebarOpen.next(true)

      }

    }
  }
  mouseHover() {
    const body = this.elementRef.nativeElement.closest('body');
    if (body.classList.contains('submenu-closed')) {
      this._glob.onSidebarOpen.next(true)
      this.renderer.addClass(this.document.body, 'side-closed-hover');
      this.renderer.removeClass(this.document.body, 'submenu-closed');
    }
  }
  mouseOut() {
    const body = this.elementRef.nativeElement.closest('body');
    if (body.classList.contains('side-closed-hover')) {
      this._glob.onSidebarOpen.next(false)
      this.renderer.removeClass(this.document.body, 'side-closed-hover');
      this.renderer.addClass(this.document.body, 'submenu-closed');
    }
  }
  logout() {
    this.authService.logout().then((res: any) => {
      if (res.success) {
        this.router.navigate(['/authentication/signin']);
        this._glob.productsInCart = []
      }
    });
  }
  public isActive(url: string): boolean {
    if (this.router.url.includes('/review') && url.includes('/orders/history'))
      return true
    else if (this.router.url.includes('/products') && url.includes('/shop/maleman'))
      return true
    else
      return this.router.url.includes(url);
  }
}
